import React, { useState } from "react";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import { InputTextarea, SubmitLoaderButton } from "components/atoms";
import {
  AddRejectReasonAction,
  UpdateRejectReasonAction,
} from "store/middlewares/dataManagement/rejectReason";
// import { Button } from "components/ui";

function ModalEditRejectReason({ row, type, filter }) {
  const dispatch = useDispatch();
 const [formError, setFormError] = useState(false);
  const handleSubmit = (values) => {
    let tempObj = { ...values, type: type,onSuccess: () => formik.setSubmitting(false), onError: () => {
      setFormError(true);
      formik.setSubmitting(false);
    }, };
    if (row) {
      tempObj = { ...tempObj, id: row?.id };
      dispatch(UpdateRejectReasonAction(tempObj));
    } else {
      dispatch(AddRejectReasonAction({ ...tempObj, filter }));
    }
  };

  const formik = useFormik({
    initialValues: {
      note: row?.note ? row?.note : "",
      // title: row?.title ? row?.title : "",
    },
    validationSchema: Yup.object({
      note: Yup.string().required("Reason is required"),
      // title: Yup.string().required("Title is required"),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="flex flex-col gap-4">
        {/* <Input
          error={formik.errors.title && formik.touched.title}
          label="Title"
          errorMsg={formik.errors.title}
          value={formik.values.title}
          type="text"
          name="title"
          isSpace={true}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Enter title"
          className={"!py-0 w-full"}
        /> */}
        <InputTextarea
          textareaClassName={`rounded-lg  w-full px-2 py-2 mt-2 no-scrollbar`}
          label={"Reason"}
          name="note"
          onChange={(e) => {
            const cleaned = e.target.value.replace(/^\s+/, "");
            formik.setFieldValue("note", cleaned);
          }}
          maxLength={100}
          onBlur={formik.handleBlur}
          error={formik.errors.note && formik.touched.note}
          errorMsg={formik.errors.note}
          value={formik.values.note}
          placeholder="Enter reason"
          isRequired={false}
        />
      </div>
      <div className="flex justify-end">
        {/* <Button size={"lg"} type={"submit"}>
          {row ? "Update" : "Add"}
        </Button> */}
        <SubmitLoaderButton  btnText={row ? "Update" : "Add"}
                isDisable={formik.isSubmitting && !formError}   />
      </div>
    </form>
  );
}

export default ModalEditRejectReason;
